var lastIntensity = 1;

module.exports = {
    initBucketPump: function(pixiFlux, intensity)
    {
        var prevIntensity = lastIntensity;
        lastIntensity = intensity;
        if (prevIntensity >= intensity) {
            // return;
        }

        if (pixiFlux) {
            var movingWalls = pixiFlux.getMovingWalls();
            _.each(movingWalls, function(movingWall) {
                if (movingWall.name === 'bucketPump') {
                    movingWall.timeline.play();
                }
            });
        }
    },

    updateBucketIntensity: function(pixiFlux, opts)
    {
        opts = _.extend({
            intensity: 1,
            minIntensity: 1,
            maxIntensity: 1
        }, opts);

        var intensityRatio = (opts.intensity - opts.minIntensity) / (opts.maxIntensity - opts.minIntensity);

        if (pixiFlux)
        {
            var movingWalls = pixiFlux.getMovingWalls();
            _.each(movingWalls, function(movingWall){
                if (movingWall.name === 'bucketHolder') {
                    TweenMax.to(movingWall.timeline, 5, {
                        progress: intensityRatio,
                        ease: Quad.easeInOut
                    });
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./js/animations/bucketGuards.js